module.exports = __webpack_public_path__ + "static/media/loginBkg.9c527b65.jpg";